<template>
  <div class="content" v-if="isShow">
    <div class="headerarea">
      <Header ></Header>
    </div>
    <div class="nav">
      <Nav></Nav>
      <!-- <SubNav v-show="$route.name!=='home'"></SubNav> -->
    </div>
    <div class="corearea">
      <router-view :key="Math.random()" />
    </div>
    <div v-if="$route.name!='Show'">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './index/Header.vue'
import SubHeader from './index/SubHeader.vue'
import Footer from './index/Footer.vue'
import Nav from './index/Nav.vue'
import SubNav from './index/SubNav.vue'
import { getFindAll, getFindPage,getme } from '../request/get'

const rate= window.outerWidth/1440;
export default {
  metaInfo: {
    title: ' 职业发展规划工作项目组',
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  name: "index",
  components: {
    Header,
    Nav,
    SubHeader,
    SubNav,
    Footer
  },
  data() {
    return {
    }
  },
  computed: {
    isShow() {
      return this.$store.getters.isShow;
    }
  },
  created() {
    console.log(this.$route.name);
    this.getFindPage();
    // this.getme()
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function(event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    async getme(){
      let result = await getme();
       localStorage.setItem("eleTokensxwf001", result.data);
        // 解析token
        const decode =  result.data;
        // 存储数据
        this.$store.dispatch("setIsAutnenticated", true);
        this.$store.dispatch("setUser", decode);
    },
    async getFindPage() {
      let result = await getFindPage();
      result = result.data || [];
      this.$store.dispatch("SET_PLATES", result)
    },
    
  }
};
</script>
<style scoped>
.content{
  position: relative;
  min-height: 100%;

}
.nav{
  position: relative;
  /* width: 1300px; */
    margin: 0 auto;
    /* background: rgba(255,255,255,0.5); */
    border-radius: 8px 8px 0 0 ;
}
.headerarea{
  position: relative;
  width: 100%; 
  margin: 0 auto;
}
.corearea{
  position: relative;
  width: 100%;
  margin: 0 auto;
}
</style>
